// these are  the keys we get from the backend API response
export enum APIConfigModulesName {
    /* eslint-disable no-unused-vars */
    practiceSupport = "practice-support",
    technicalSupport = "technical-support",
    questionnaireService = "questionnaires-service",
}

// these are the keys we gonna use on the frontend to store the config values
export enum FEConfigModulesName {
    practiceSupport = "practiceSupport",
    technicalSupport = "technicalSupport",
    questionnaireService = "questionnaireService",
}
